export function setBrowserTitle(title) {
  if (!title || typeof document === 'undefined') return;
  document.title = title;
}

export function setFavicon(href) {
  if (!href || typeof document === 'undefined') return;
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.href = href;
}

const DEFAULT_COMPANY_NAME = process.env.REACT_APP_COMPANY_NAME || 'Lazer';

export function applyBrowserBranding({ companyName, logoUrl, pageLabel }) {
  const brandName = companyName || DEFAULT_COMPANY_NAME;
  const pageTitle = pageLabel ? `${pageLabel} - ${brandName}` : brandName;
  setBrowserTitle(pageTitle);
  setFavicon(logoUrl || '/favicon.ico');
}
